import React from "react";
import { useTranslation } from "react-i18next";
import "./Footer.css";

function Footer() {
  const { t } = useTranslation("common");

  return (
    <div id="footer">
      <p id="copyright">
        {t("footer.copyright", { year: new Date().getFullYear() })}
      </p>
      <div className="contact">
        <a
          href="https://github.com/EricYoung37"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-github" />
        </a>
        <a
          href="https://www.linkedin.com/in/ericyoung6"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-linkedin" />
        </a>
      </div>
    </div>
  );
}

export default Footer;
